import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { predictionService } from '../../services/predictionService';
import './Prediction.css';

export const PredictionDetail = () => {
  const { id } = useParams();
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrediction = async () => {
      try {
        if (id) {
          const data = await predictionService.getPrediction(parseInt(id));
          setPrediction(data);
        }
      } catch (error) {
        console.error('Error fetching prediction:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrediction();
  }, [id]);

  if (loading) return <div className="loading">Cargando...</div>;
  if (!prediction) return <div className="error">Predicción no encontrada</div>;

  return (
    <article className="prediction-post">
      <h1>{prediction.title}</h1>
      <div className="post-meta">
        <time>{new Date(prediction.published_at).toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}</time>
        
        <div className="astro-data">
          {prediction.moon_phase && (
            <span className="moon-phase">
              Fase lunar: {prediction.moon_phase}
            </span>
          )}
          {prediction.astro_sign && (
            <span className="astro-sign">
              Signo dominante: {prediction.astro_sign}
            </span>
          )}
        </div>
        
        <div className="tags">
          {prediction.tags.map((tag) => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
      </div>
      <div className="post-content">{prediction.content}</div>
    </article>
  );
}; 